import { EventName, EventType, MetricsForJumboEvent } from '../constants';
import { createAndSendEvent } from '../jumboClient';
import { stringifyFeatureMeta } from '../utils';

// Normalizes feature_meta once here, rather than at each call site.
const send = (eventName, properties = {}, eventType) => {
  const metaKey = MetricsForJumboEvent.feature_meta;
  const normalizedProperties = properties[metaKey]
    ? { ...properties, [metaKey]: stringifyFeatureMeta(properties[metaKey]) }
    : properties;
  createAndSendEvent(eventName, normalizedProperties, eventType);
};

// Panel-level
export const CopilotButtonClickedEvent = (properties = {}) =>
  send(EventName.COPILOT_BUTTON_CLICKED, properties, EventType.CLICK);

export const CopilotFlowDropOffEvent = (properties = {}) =>
  send(EventName.COPILOT_FLOW_DROP_OFF, properties);

export const CopilotUploadedImageViewClickEvent = (properties = {}) =>
  send(EventName.COPILOT_UPLOADED_IMAGE_VIEW_CLICK, properties);

// Step 1 - Order & Product Confirmation
export const Step1OpenedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_1_OPENED, properties, EventType.SHOWN);

export const Step1ProductSelectionChangedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_1_PRODUCT_SELECTION_CHANGED, properties);

export const Step1CtaClickedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_1_CTA_CLICKED, properties);

export const Step1CtaResponseEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_1_CTA_RESPONSE, properties);

// Step 2 - Complaint Identification
export const Step2OpenedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_2_OPENED, properties, EventType.SHOWN);

export const Step2ComplaintTypeChangedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_2_COMPLAINT_TYPE_CHANGED, properties);

export const Step2CtaClickedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_2_CTA_CLICKED, properties);

export const Step2CtaResponseEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_2_CTA_RESPONSE, properties);

// Step 3 - Verification
export const Step3OpenedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_3_OPENED, properties, EventType.SHOWN);

export const Step3ChecklistItemToggledEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_3_CHECKLIST_ITEM_TOGGLED, properties);

export const Step3GrievanceLevelSelectedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_3_GRIEVANCE_LEVEL_SELECTED, properties);

export const Step3CtaClickedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_3_CTA_CLICKED, properties);

export const Step3CtaResponseEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_3_CTA_RESPONSE, properties);

export const Step3CannotVerifyResponseShownEvent = (properties = {}) =>
  send(
    EventName.COPILOT_STEP_3_CANNOT_VERIFY_RESPONSE_SHOWN,
    properties,
    EventType.SHOWN,
  );

// Step 4 - Resolution
export const Step4OpenedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_4_OPENED, properties, EventType.SHOWN);

export const Step4PickupToggledEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_4_PICKUP_TOGGLED, properties);

export const Step4ResolutionTypeSelectedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_4_RESOLUTION_TYPE_SELECTED, properties);

export const Step4CtaClickedEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_4_CTA_CLICKED, properties);

export const Step4CtaResponseEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_4_CTA_RESPONSE, properties);

export const Step4TagsAddedOnCloseEvent = (properties = {}) =>
  send(EventName.COPILOT_STEP_4_TAGS_ADDED_ON_CLOSE, properties);
